export enum TranscriberProviderEnum {
  Azure = 'azure',
  Deepgram = 'deepgram',
  Hamsa = 'hamsa',
  OpenAI = 'openai',
}

export enum TranscriberLanguageEnum {
  AR = 'ar-SA',
  EN = 'en-US',
  FR = 'fr-FR',
  CH = 'ch-CN',
}
